import React from "react";
import _ from "lodash";
import Select from "react-select";
import ModalWrapper from "components/common/ModalWrapper";
import ModalFooter from "components/common/ModalFooter";
import CustomRulesSelector from "../custom-upr/CustomRulesSelector";
import { inputClass } from "helpers/StyleClass";
import { MESSAGE } from "constants/Message";

const buttonActionClass =
  "px-2 py-1 bg-gray-200 text-xs rounded border border-gray-400 whitespace-pre shadow hover:bg-gray-300 text-gray-900 font-semibold";

const ACTION = {
  UPDATE_LABEL: "updateLabel",
};

class BatchUpdateButton extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isOpenModal: false,
    };

    this.handleCloseModal = this.handleCloseModal.bind(this);
  }

  // Ref function
  handleCloseModal() {
    this.setState({ isOpenModal: false });
  }

  render() {
    const { isOpenModal } = this.state;
    const { selected, rules, handleBatchUpdate } = this.props;

    return (
      <>
        <button
          className={buttonActionClass}
          onClick={() => this.setState({ isOpenModal: true })}
        >
          Batch Update
        </button>
        {isOpenModal && (
          <BatchUpdateModal
            selected={selected}
            rules={rules}
            onClose={() => this.setState({ isOpenModal: false })}
            onBatchUpdate={handleBatchUpdate}
          />
        )}
      </>
    );
  }
}

class BatchUpdateModal extends React.Component {
  constructor(props) {
    super(props);

    const { selected } = this.props;

    this.state = {
      msg: [],
      selectedRuleIds: selected || [],
      selectedAction: ACTION.UPDATE_LABEL,
      actionOption: [{ value: ACTION.UPDATE_LABEL, label: "Update Label" }],

      // Update Label
      labelInput: "",
    };

    this.handleRulesChanged = this.handleRulesChanged.bind(this);
    this.handleBatchUpdate = this.handleBatchUpdate.bind(this);
  }

  handleRulesChanged(list) {
    this.setState({ selectedRuleIds: list });
  }

  handleBatchUpdate() {
    const { selectedRuleIds, selectedAction, labelInput } = this.state;

    this.setState({ msg: [] });

    if (selectedAction === ACTION.UPDATE_LABEL) {
      if (labelInput.trim() === "") {
        this.setState({ msg: ["Label could not be empty.", MESSAGE.ERROR] });
        return;
      }
      this.props.onBatchUpdate({
        selected: selectedRuleIds,
        content: { label: labelInput },
        type: "label",
      });
    }
  }

  render() {
    const { onClose, rules } = this.props;

    const { selectedRuleIds, selectedAction, labelInput, actionOption, msg } =
      this.state;

    const parseSelectedAction = actionOption.find(
      (option) => option.value === selectedAction
    );

    return (
      <ModalWrapper
        isOpen={true}
        showCloseFooter={false}
        handleClose={onClose}
        customOverlayStyle={{ zIndex: 100 }}
        width="75%"
        height="70%"
        title="Batch Update Rules"
      >
        <div
          className="rounded border mb-2 overflow-y-auto"
          style={{ height: "calc(100% - 6rem)" }}
        >
          <div className=" mb-4 bg-white px-6 pb-6 pt-4">
            <div className="mb-4">
              <label className="block text-lg font-bold text-gray-800">
                Select rules to update ({selectedRuleIds.length})
              </label>
              <CustomRulesSelector
                rules={rules}
                selectedItems={selectedRuleIds}
                handleChanged={this.handleRulesChanged}
              ></CustomRulesSelector>
            </div>
            <div className="border-b mb-4 pb-4">
              <label className="block text-lg font-bold text-gray-800">
                Select action
              </label>
              <Select
                value={parseSelectedAction}
                onChange={(option) =>
                  this.setState({ selectedAction: option.value })
                }
                options={actionOption}
              ></Select>
            </div>
            {!_.isEmpty(selectedRuleIds) && selectedAction && (
              <div className="mb-4 bg-gray-300 px-4 py-2">
                {selectedAction === ACTION.UPDATE_LABEL && (
                  <div className="w-1/3">
                    <label
                      className="block font-bold text-gray-800"
                      htmlFor="label"
                    >
                      Label
                    </label>
                    <input
                      className={inputClass}
                      id="label"
                      type="text"
                      value={labelInput}
                      onChange={(e) =>
                        this.setState({ labelInput: e.target.value })
                      }
                    />
                  </div>
                )}
              </div>
            )}
          </div>
        </div>
        <ModalFooter
          msg={msg}
          confirmText="Update"
          onCancel={onClose}
          onConfirm={this.handleBatchUpdate}
        />
      </ModalWrapper>
    );
  }
}

export default BatchUpdateButton;
